export interface HorizontalDividerProps {
  className?: string;
}

export default function HorizontalDivider({
  className,
}: HorizontalDividerProps) {
  return <div className={`h-[1px] w-full bg-divider ${className}`}></div>;
}
